import { loadModules } from "esri-loader";

const extractShapeFileFromGraphicJSON = graphicsAsJsonString => {
  return new Promise((resolve, reject) => {
    loadModules(["esri/request"]).then(([esriRequest]) => {
      let request = {
        format: "shp",
        featureSets: graphicsAsJsonString,
        f: "json"
      };

      esriRequest(process.env.VUE_APP_EXTRACT_SHAPE_SERVICE_URL, {
        query: request,
        useProxy: true,
        responseType: "json"
      })
        .then(response => {
          resolve(response.data.href);
        })
        .catch(error => {
          reject(error);
        });
    });
  });
};

const getGraphicsAsJsonString = async graphics => {
  let realJson = [];
  for (let graphicIndex = 0; graphicIndex < graphics.length; graphicIndex++) {
    let graphic = graphics[graphicIndex];
    let graphicJson = await getGraphicAsJson(graphic);
    realJson.push(graphicJson);
  }

  return JSON.stringify(realJson);
};

const getGraphicAsJson = async graphic => {
  graphic = await makeGraphicValid(graphic);

  if (graphic.symbol && graphic.symbol.font) {
    graphic.attributes["size"] = graphic.symbol.font.size;
  }

  let graphicJson = graphic.toJSON();
  delete graphicJson.symbol;
  let geometryType = graphic.geometry.type;

  geometryType = capitalizeString(geometryType);

  let graphicjson = {
    name: geometryType,
    featureSet: {
      spatialReference: {
        wkid: 25833
      },
      geometryType: "esriGeometry" + geometryType,
      features: [graphicJson]
    }
  };

  return graphicjson;
};

const capitalizeString = stringToBeCapitalized => {
  return (
    stringToBeCapitalized.charAt(0).toUpperCase() +
    stringToBeCapitalized.slice(1)
  );
};

const makeGraphicValid = async graphic => {
  return new Promise((resolve, reject) => {
    loadModules(["esri/Graphic"])
      .then(async ([Graphic]) => {
        if (!(graphic instanceof Graphic)) {
          let validGeometry = await createValidGeometry(graphic.geometry);

          let tempGraphic = new Graphic({
            geometry: validGeometry,
            attributes: graphic.attributes
          });
          resolve(tempGraphic);
        } else {
          resolve(graphic);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
};

const createValidGeometry = geometryJson => {
  return loadModules([
    "esri/geometry/Polygon",
    "esri/geometry/Polyline",
    "esri/geometry/Point"
  ]).then(([Polygon, Polyline, Point]) => {
    if (geometryJson.rings) {
      return new Polygon({
        rings: geometryJson.rings,
        spatialReference: { wkid: 25833 }
      });
    } else if (geometryJson.paths) {
      return new Polyline({
        paths: geometryJson.paths,
        spatialReference: { wkid: 25833 }
      });
    } else {
      return new Point({
        x: geometryJson.x,
        y: geometryJson.y,
        spatialReference: { wkid: 25833 }
      });
    }
  });
};

export {
  extractShapeFileFromGraphicJSON,
  getGraphicsAsJsonString,
  createValidGeometry
};
